import React, { useState } from 'react';
import PlanchetteIntelDashboard from '../components/planchette-intel/PlanchetteIntelDashboard';
import EntityDetail from '../components/planchette-intel/EntityDetail';
import GraphVisualization from '../components/planchette-intel/GraphVisualization';

const TABS = [
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'entities', label: 'Entities' },
  { id: 'findings', label: 'Findings' },
  { id: 'watches', label: 'Watches' },
];

const PlanchetteIntel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const [showGraph, setShowGraph] = useState(false);

  const handleEntitySelect = (entityId) => {
    setSelectedEntityId(entityId);
    setActiveTab('detail');
  };

  const handleShowGraph = (entityId) => {
    setSelectedEntityId(entityId);
    setShowGraph(true);
  };

  const handleBack = () => {
    if (showGraph) {
      setShowGraph(false);
    } else {
      setSelectedEntityId(null);
      setActiveTab('dashboard');
    }
  };

  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="bg-virgo-navy-700 border-b border-virgo-teal-800 px-6 py-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-virgo-gold-400">PlanchetteIntel</h1>
            <p className="text-sm text-gray-400 mt-1">Entity resolution, relationship graphing & OSINT intelligence</p>
          </div>
        </div>

        {/* Tabs */}
        {!showGraph && activeTab !== 'detail' && (
          <div className="flex gap-1 mt-4">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-4 py-2 rounded-t-lg text-sm font-medium transition-colors ${
                  activeTab === tab.id
                    ? 'bg-virgo-navy-800 text-virgo-teal-400 border-b-2 border-virgo-teal-400'
                    : 'text-gray-400 hover:text-gray-200 hover:bg-virgo-navy-800/50'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {/* Back button for detail/graph views */}
        {(showGraph || activeTab === 'detail') && (
          <button
            onClick={handleBack}
            className="mt-4 flex items-center gap-2 text-sm text-gray-400 hover:text-virgo-teal-400 transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {showGraph ? 'Back to Entity' : 'Back to Dashboard'}
          </button>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto">
        {showGraph && selectedEntityId && (
          <GraphVisualization entityId={selectedEntityId} />
        )}
        {!showGraph && activeTab === 'detail' && selectedEntityId && (
          <EntityDetail
            entityId={selectedEntityId}
            onShowGraph={handleShowGraph}
            onBack={handleBack}
          />
        )}
        {!showGraph && activeTab !== 'detail' && (
          <PlanchetteIntelDashboard
            activeTab={activeTab}
            onEntitySelect={handleEntitySelect}
            onShowGraph={handleShowGraph}
          />
        )}
      </div>
    </div>
  );
};

export default PlanchetteIntel;
